import React, { createContext, useContext, useMemo, useState } from 'react';

const SlideIndexContext = createContext();

export function SlideIndexProvider({ children }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const value = useMemo(() => ({ currentIndex, setCurrentIndex }), [currentIndex]);
  return (
    <SlideIndexContext.Provider value={value}>
      {children}
    </SlideIndexContext.Provider>
  );
}

export function useSlideIndex() {
  const context = useContext(SlideIndexContext);
  if (!context) {
    throw new Error('useSlideIndex deve ser usado dentro de um SlideIndexProvider');
  }
  return context;
}
